

import Component from "vue-class-component";
import { InjectReactive } from "vue-property-decorator";
import { $t } from "@/lib/i18nHelpers";
import Original from "@/components/CallController/components/CallNotification/CallNotification";

@Component({ name: "PaidCallNotification" })
export default class PaidCallNotification extends Original {
  @InjectReactive({ from: "paidCallPrice", default: 0 })
  public readonly callPrice!: number;

  public get description() {
    const status = this.opponentSubscriptionStatus;
    if (this.callPrice > 0) {
      let fromText = status !== "user" ? $t("from your {0}", [$t(status)]) : "";
      return $t("Paid call{0}", [" " + fromText]);
    } else if (status !== "user") return $t("Your {0}", [$t(status)]);
    return "";
  }
}
